import React, { FC } from 'react';

import { useTranslation } from 'react-i18next';

import useStyles from './styles';

interface SwitchProps {
  value: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onOff?: boolean;
  'data-testid'?: string;
}

const Switch: FC<SwitchProps> = ({ value = false, onChange = () => {}, onOff = false, ...rest }) => {
  const classes = useStyles(onOff)();
  const { t } = useTranslation();

  return (
    <div className={classes.switch} data-testid={rest['data-testid']}>
      <input
        className={classes.input}
        type="checkbox"
        id="switch"
        onChange={onChange}
        checked={value}
      />
      <label data-testid="switcher" className={classes.label} htmlFor="switch">
        {t('input.label.toggle')}
      </label>
    </div>
  );
};

export default Switch;
